import {
  Box,
  Container,
  Heading,
  Text,
  Stack,
  Image,
  SimpleGrid,
  VStack,
  useBreakpointValue,
  Button,
  Link,
} from "@chakra-ui/react";

const locations = [
  {
    name: "Vishal Hadwares – Bandra West (Flagship Center)",
    image: "/assets/locations/bandra.jpg",
    address:
      "Shop No. 8, Harmony Plaza, 15th Road, Bandra (W), Mumbai – 400050",
    phone: "+91 98765 43210",
    timings: "9:00 AM – 8:00 PM (Mon–Sun)",
    highlights: [
      "Spacious therapy suites",
      "State-of-the-art colon hydrotherapy equipment",
      "Personalized nutrition consultations",
      "Nearby cafés and wellness stores",
    ],
    mapEmbedUrl:
      "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d241317.11609826244!2d72.74110084999999!3d19.082197799999996!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3be7c956cf2e9b01%3A0x1d37c2b8b3cf5ae1!2sBandra%20West%2C%20Mumbai!5e0!3m2!1sen!2sin!4v1693645130306!5m2!1sen!2sin",
  },
  {
    name: "Vishal Hadwares – Powai",
    image: "/assets/locations/powai.jpg",
    address:
      "3rd Floor, Nirvana Wellness Hub, Hiranandani Gardens, Powai, Mumbai – 400076",
    phone: "+91 98201 12345",
    timings: "10:00 AM – 7:00 PM (Tue–Sun)",
    highlights: [
      "Convenient for IT professionals and residents",
      "Eco-friendly interiors with calming ambience",
      "Yoga & detox packages available",
      "Easy access to metro and parking",
    ],
    mapEmbedUrl:
      "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3769.2939813748774!2d72.90258031421758!3d19.128289787057843!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3be7c7f501772b37%3A0x2263aaf14224f917!2sPowai%2C%20Mumbai!5e0!3m2!1sen!2sin!4v1693645304422!5m2!1sen!2sin",
  },
  {
    name: "Vishal Hadwares – South Mumbai (Marine Drive)",
    image: "/assets/locations/marine.jpg",
    address:
      "Unit 2A, Ocean View Complex, Marine Drive, Churchgate, Mumbai – 400020",
    phone: "+91 98190 67890",
    timings: "8:30 AM – 6:30 PM (Mon–Sat)",
    highlights: [
      "Ideal for corporate clients and wellness tourists",
      "Sea-facing therapy suites for ultimate relaxation",
      "Certified colonic practitioners with decades of experience",
      "Ayurveda & gut health supplements available",
    ],
    mapEmbedUrl:
      "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3762.711994425934!2d72.8180152142297!3d18.94699608716402!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3be7cf26cc21e85d%3A0xf5c2efcf1a321fea!2sMarine%20Drive%2C%20Mumbai!5e0!3m2!1sen!2sin!4v1693645427326!5m2!1sen!2sin",
  },
];

const LocationsPage = () => {
  return (
    <Box bg="#3D5940" py={16} px={4} fontFamily="'Georgia', serif">
      <Container maxW="6xl" textAlign="center" mb={12}>
        <Heading fontSize="3xl" color="#3D5940" mb={4}>
          Our Locations
        </Heading>
        <Text fontSize="md" maxW="700px" mx="auto" color="#3D5940">
          Visit our thoughtfully curated wellness spaces across Mumbai for
          rejuvenation, peace, and transformative colonic therapy.
        </Text>
      </Container>

      <SimpleGrid columns={{ base: 1, md: 2 }} spacing={10}>
        {locations.map((loc) => (
          <Box
            key={loc.name}
            bg="white"
            borderRadius="3xl"
            boxShadow="lg"
            overflow="hidden"
            display="flex"
            flexDirection="column"
            justifyContent="space-between"
          >
            {/* Image */}
            <Image
              src={loc.image}
              alt={loc.name}
              w="100%"
              h="220px"
              objectFit="cover"
            />

            {/* Content */}
            <Box p={6}>
              <Heading fontSize="xl" mb={2} color="#3D5940">
                {loc.name}
              </Heading>
              <Text color="#4A4A4A" mb={2}>
                <strong>📍 Address:</strong> {loc.address}
              </Text>
              <Text color="#4A4A4A" mb={2}>
                <strong>📞 Phone:</strong> {loc.phone}
              </Text>
              <Text color="#4A4A4A" mb={3}>
                <strong>🕒 Timings:</strong> {loc.timings}
              </Text>

              <Text fontWeight="semibold" color="#3D5940" mb={2}>
                Why choose this center?
              </Text>
              <VStack
                align="start"
                spacing={1}
                fontSize="sm"
                color="#3D5940"
                mb={4}
              >
                {loc.highlights.map((point, i) => (
                  <Text key={i}>• {point}</Text>
                ))}
              </VStack>

              <Button
                as={Link}
                href="/book"
                bg="#3D5940"
                color="white"
                _hover={{ bg: "#2C4433" }}
                borderRadius="full"
                fontWeight="medium"
                px={6}
                fontFamily="'Georgia', serif"
              >
                Book This Center
              </Button>

              {/* Google Map */}
              <Box mt={4} borderRadius="xl" overflow="hidden" h="200px">
                <iframe
                  title={`Map - ${loc.name}`}
                  src={loc.mapEmbedUrl}
                  width="100%"
                  height="100%"
                  loading="lazy"
                  style={{ border: 0 }}
                  allowFullScreen
                ></iframe>
              </Box>
            </Box>
          </Box>
        ))}
      </SimpleGrid>
    </Box>
  );
};

export default LocationsPage;
